import React, {Component} from 'react'
import {FilePond} from "react-filepond";
import {default as Links} from "../../Route";
import HttpRequest from "../../HttpRequest";
import {Tools} from "../../Tools";
import Components from "../../components";
import loading from "../../images/loading.gif"

const
    proof_component = "proof",
    formFields = {
        proof: "",
    },
    disabledAttribute = {
        disabled: "disabled",
    },
    addButtons = {
        id: "",
        set: {
            label: "Envoyer",
            action: "PUT",
            attributes: disabledAttribute,
        }
    },
    loadingInButton = (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>Waiting...</>)
;
class Proof extends Component {

    constructor(props){
        super(props);
        this.handleButtonClicked = this.handleButtonClicked.bind(this);
        this.httpClient = new HttpRequest();
        this.proof_token = props.proof_token ? props.proof_token : "x";
        this.formRef = React.createRef();

        this.server = {};
        this.state = {
            server: {},
            isLoadCompleted: false,
            proofSent: false,
            showForm: false,
            form: {
                fieldValues: Tools.Clone(formFields),
                buttons: Tools.Clone(addButtons),
            },
            files: []
        };
    }

    handleButtonClicked(event){
        // Here we add the loader in the button
        let form = this.state.form, newButtonLoader = Tools.Clone(addButtons);
        newButtonLoader.set.label = loadingInButton;
        newButtonLoader.set.attributes = disabledAttribute;
        form.buttons = newButtonLoader;
        this.setState({form: form});

        let data = {
            ...this.state.form.fieldValues,
        };

        const _self = this;
        this.httpClient.request(Links.APISetMemberProof.replace(":proof_token", this.proof_token), "PUT", {}, data).then(function (response){
            _self.server = response;
            let state = {server: response, form: form, showAlert: true};
            if(_self.server.code === 200){
                state = {proofSent: true, files: []};
            }
            form.buttons = addButtons;
            form.buttons.set.attributes = disabledAttribute;
            _self.setState({...state});
        }).catch(function (error){
            _self.server = error;
            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({server: error, form: form, showAlert: true, hasAsyncError: true});
        });
    }
    render(){
        let messageElement = "";
        if(!this.state.isLoadCompleted){
            messageElement = (<Components.PageLoader data={{
                image: {
                    src: loading,
                    alt: 'loading',
                    width: 70,
                }
            }} />);
        }

        if(this.state.isLoadCompleted && this.state.showForm && this.formRef && this.formRef.current){
            this.formRef.current.classList.remove("hidden");
        }

        if(this.state.showAlert || this.state.proofSent){
            let content = "Une erreur s'est produite !", alertClass = Components.Dialogs.ALERT_TYPES.DANGER;
            if(this.state.hasAsyncError){
                content = "Nos serveurs sont en maintenance. Revenez ultérieurement!";
            }
            else{
                if(this.state.proofSent){
                    alertClass = Components.Dialogs.ALERT_TYPES.SUCCESS;
                    this.formRef.current.classList.add("hidden");
                }
                else if(this.server && this.server.code === 201){
                    alertClass = Components.Dialogs.ALERT_TYPES.WARNING;
                }
                if(this.server.message){
                    content = this.server.message;
                }
            }
            messageElement = <Components.Dialogs.AlertDialog  data={{content: content, iconClass: "", alertClass: alertClass}} />;
        }

        return (
            <>
                <div className="inner-head bg-animate">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-md-8 col-md-offset-2">
                                <h3>Fournissez votre justificatif</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="clearfix"></div>
                <div className="inner-page">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                {messageElement}
                                <form ref={this.formRef} encType="multipart/form-data" className="hidden">
                                    <div className="row mb-3">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 mb-3 thumbnail align-center">
                                            <label>Justificatif</label>
                                            <FilePond
                                                ref={ref => (this.pond = ref)}
                                                files={this.state.files}
                                                allowMultiple={false}
                                                maxFiles={1}
                                                server={
                                                    {
                                                        url: Links.APIBaseUrl,
                                                        process: {
                                                            url: Links.APIUploadMemberFile,
                                                            method: "POST",
                                                            ondata: (formData) => {
                                                                formData.append("field_name", proof_component);
                                                                return formData;
                                                            },
                                                        },
                                                        load: Links.APILoadMemberFile,
                                                    }
                                                }
                                                name={proof_component} /* sets the file input name, it's filepond by default */
                                                onupdatefiles={fileItems => {
                                                    const files = fileItems.map(fileItem => fileItem.file);
                                                    // Set currently active file objects to this.state
                                                    this.setState({
                                                        files: files
                                                    });
                                                }}
                                                onprocessfile={(error, file) => {
                                                    if(error){
                                                        console.log(error)
                                                    }
                                                    else{
                                                        if(file.serverId){
                                                            const response = HttpRequest.parseRequestResponse(file.serverId);
                                                            if(response.code === 200){
                                                                let form = this.state.form;
                                                                form.buttons.set.attributes = null;
                                                                this.oldProof = form.fieldValues["proof"];
                                                                form.fieldValues["proof"] = response.data[proof_component + "_reference"];
                                                                this.setState({form: form});
                                                            }
                                                        }
                                                    }
                                                }}
                                                onremovefile={(error, file) => {
                                                    let form = this.state.form;
                                                    form.buttons.set.attributes = disabledAttribute;
                                                    form.fieldValues["proof"] = null;
                                                    this.setState({form: form});
                                                }}
                                            />
                                            Selectionnez votre justificatif
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 mb-3">
                                            <button className="btn btn-primary btn-lg btn-block" type="button" {...this.state.form.buttons.set.attributes} onClick={this.handleButtonClicked} data-id={this.state.form.buttons.id} data-action={this.state.form.buttons.set.action}>{this.state.form.buttons.set.label}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    componentDidMount() {
        const _self = this;
        this.httpClient.request(Links.APISetMemberProof.replace(":proof_token", this.proof_token), "GET").then(function (response){
            _self.server = response;
            let state = {server: response, isLoadCompleted: true};
            if(_self.server.code === 200){
                state.showForm = true;
            }
            else{
                state.showAlert = true;
            }
            _self.setState({...state});
        }).catch(function (error){
            _self.setState({showAlert: true, hasAsyncError: true});
        });
    }
}

export default Proof;